// TODO: Remove this file after 01/01/2023 or adjust to make more generic

import moment from 'moment-timezone';

import { REGION_COVERAGE_RULES } from '../../constants/regionConfigs';

const IL_VUMPD_CUTOFF_DATE = '2022-12-31';
const compareDate =
  process.env.REACT_APP_ENV === 'production' ||
  process.env.REACT_APP_ENV === 'test' ||
  !!window.Cypress
    ? moment(IL_VUMPD_CUTOFF_DATE)
    : moment('2022-12-15');

export function getVUMPDRuleBasedOnEffectiveDate(policyEffectiveDate: string) {
  const { VUMPD_REQUIRES_NO_COMP_COLL } = REGION_COVERAGE_RULES;
  const isEffectiveDatePast =
    moment.utc(policyEffectiveDate).startOf('day').diff(compareDate) > 0;
  const isTodayDatePast = moment.utc().startOf('day').diff(compareDate) > 0;

  const isCoverageRuleRemovedForIL = isEffectiveDatePast || isTodayDatePast;

  if (isCoverageRuleRemovedForIL) {
    return VUMPD_REQUIRES_NO_COMP_COLL.filter((region) => region !== 'IL');
  }

  return VUMPD_REQUIRES_NO_COMP_COLL;
}
